import { useContext } from "react";

import { CustomerLtvV2Context } from "./context";

export const useCustomerLtvV2 = () => {
  const context = useContext(CustomerLtvV2Context);

  if (!context) {
    throw new Error(
      "useCustomerLtvV2 can only be used inside CustomerLtvV2Provider",
    );
  }

  return context;
};
